import { http, httpV2 } from "@/api";

/**
 * Solicita as propriedades do parque/planta.
 * @param {number} monitoringElementId Id do elemento de monitoramento do tipo planta/parque.
 * @returns {object} Propriedades do parque/planta.
 */
const GetPark = function(monitoringElementId)
{
	return httpV2.get(`WindParks/${monitoringElementId}`);
};

/**
 * Solicita as turbinas/unidades geradoras filhas de um parque/planta.
 * @param {number} monitoringElementId Id do elemento de monitoramento do tipo planta/parque.
 * @returns {array} Turbinas filhas do parque/planta.
 */
const GetTurbines = function(monitoringElementId)
{
	return httpV2.get(`WindParks/${monitoringElementId}/WindTurbines`);
};

/**
 * Solicita as notificações ocorridas para o parque/planta.
 * @param {number} monitoringElementId Id do elemento de monitoramento do tipo planta/parque.
 * @param {number} startDateTime Data/hora de início.
 * @param {number} endDateTime Data/hora de fim.
 * @returns {array} Notificações ocorridas para o parque/planta.
 */
const GetNotificationsLogs = function(monitoringElementId, startDateTime, endDateTime)
{
	return http.get(`/WindParkEventsLog/
		${monitoringElementId}?startDateTime=
		${startDateTime}&endDateTime=
		${endDateTime}`);
};

export default {
	GetPark,
	GetTurbines,
	GetNotificationsLogs
};